module.exports = __webpack_public_path__ + "assets/img/df9c-dg.svg";